import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-type-time",
  "use": "icon-type-time-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-type-time\"><path d=\"m16 4 .304.004C22.764 4.166 28 9.502 28 16c0 6.6-5.4 12-12 12S4 22.6 4 16 9.4 4 16 4m0 2C10.4 6 6 10.4 6 16c0 5.505 4.252 9.85 9.716 9.996L16 26c5.6 0 10-4.4 10-10S21.6 6 16 6m1 3v7.6l3.8 3.6-1.6 1.6-4.2-4.4V9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol